const PLATFORM_SUFFIX_MAP = {
    'web.g5en': 'browser_game',
    'g5en': 'web',
    'g5en.webbank': 'web',
    'web.g5shop': 'web',
    'winrt.g5en': 'winrt',
    'winrt': 'winrt_ms',
};

const getPlatformFromInappId = (id) => {
    const match = id?.match(/com\.g5e\.[^.]+\.(.+)|\.([^.]+)\.g5store/);
    const suffix = match?.[1] ?? match?.[2];
    if (!suffix) return undefined;

    if (suffix in PLATFORM_SUFFIX_MAP) return PLATFORM_SUFFIX_MAP[suffix];
    if (suffix === 'win' || suffix.startsWith('win.')) return 'winrt';

    return suffix.match(/^(winrt|web\.g5en|web|ios|mac|android)(\.|$)/)?.[1];
};

export default getPlatformFromInappId;
